import { useContext, useState } from "react";
import { useCallback } from "react";
import { HimmaContext } from "../Context/HimmaContext";


export const useOrderManagementApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);


  const getAllOrderManagement = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.getAllOrders(
           query.userType,
          query.userId,
          undefined,
          query.page,
          query.limit,
          // query.merchantId,
          query.orderId,
          undefined,
          query.status,
          query.fromDate,
          query.toDate,
          query.sortBy,
          query.sortOrder,
          query.search,
          // Filter by order mode (normal / preOrder) when provided
          query.orderMode,
          // We are not using requiresManualAssignment filter from UI for now
          undefined
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : "An error occurred");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );


  return {
   getAllOrderManagement,
    loading,
    error,
  };
};
